// Components==============
import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import React, { createContext } from 'react';
import Groups from './components/Groups';
import './index.module.scss';
// =========================

export const DashboardContext = createContext(null);

export default function Dashboard() {
    return (
        <DashboardContext.Provider value={{}}>
            <Layout>
                <div styleName="wrapper">
                    <Container>
                        <h3 styleName="title">Groepen</h3>
                        <Groups />
                    </Container>
                </div>
            </Layout>
        </DashboardContext.Provider>
    );
}
